module.exports = __webpack_public_path__ + "img/banner1.5467a387.png";